import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Checkbox } from '@pwc/pwc-deals-ui';

import classNames from 'classnames';

const SortOrderCell = ({
  sortOrder,
  contentThreadId,
  isSelected,
  isDragAllowed,
  isDragEnabled,
  onSelect,
  index,
}) => {
  const iconClassNames = classNames('fill', {
    enabled: isDragAllowed,
  });

  const handleChange = () => {
    onSelect(contentThreadId, !isSelected, index);
  };

  return (
    <>
      {isDragEnabled && (
        <div className="sort-order-cell-icon">
          <Icon
            name="arrow-up-down"
            width="20"
            className={iconClassNames}
            data-testid="arrow-up-down-icon"
          />
          <Checkbox
            disabled={!isDragAllowed}
            dataTestId="select-for-drag-checkbox"
            id={`select-for-drag-checkbox-${contentThreadId}`}
            checked={isSelected}
            onChange={handleChange}
          />
        </div>
      )}
      <div data-testid="sort-order-cell" className="sort-order-cell">
        <div className="sort-order-cell-wrapper">{sortOrder}</div>
      </div>
    </>
  );
};

SortOrderCell.propTypes = {
  sortOrder: PropTypes.number.isRequired,
  contentThreadId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  isSelected: PropTypes.bool,
  isDragAllowed: PropTypes.bool,
  isDragEnabled: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

SortOrderCell.defaultProps = {
  isSelected: false,
  isDragAllowed: false,
  isDragEnabled: false,
};

export default SortOrderCell;
